import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import {
  provideDarkTheme,
  remoteConfigProviders,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders, vkforgContextProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { loginProviders, withLogin } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { provideMdeInventoryModule } from '@softapps/mde/inventory';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { artikelvorratProviders } from '@softapps/mde/artikelvorrat';
import { materiallieferscheinScanProviders } from '@softapps/mde/materiallieferschein-scan';
import { warenuebernahmeProviders } from '@softapps/wws/warenuebernahme';
import { eslLinkProviders } from '@softapps/handel/esl-link';
import { provideGarageOrderModule } from '@softapps/werkstatt/order';
import {
  provideSoftApps,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_PUBLIC,
  SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING,
} from '@softapps/core';
import { publicRoutes, shellRoutes } from './app.routes';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { provideGarageReport } from '@softapps/werkstatt/report';
import { provideRoster } from '@softapps/pms/roster';
import { withGarageRoster } from '@softapps/werkstatt/roster';
import { provideGarageCore } from '@softapps/werkstatt/garage-core';
import { provideToolModule, provideVehicleModule } from '@softapps/werkstatt/vehicle';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([]),
    provideSoftApps({ connection: environment.connection }, withLogin()),

    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },

    { provide: SOFTLINE_ROUTES_APPS, useValue: shellRoutes, multi: true },
    { provide: SOFTLINE_ROUTES_PUBLIC, useValue: publicRoutes, multi: true },
    { provide: SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING, useValue: true },

    /*
    importProvidersFrom(
      BrowserAnimationsModule,
      RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),

      // Framework
      CoreModule.forRoot(),
      StoreModule.forRoot(),
      ConnectionModule.forRoot(environment.connection),
      AuthenticationModule.forRoot(),
      JwtAuthenticationModule.forRoot(),
      ApplicationModule.forRoot(),
      AppearanceModule.forRoot(),
      DynamicModule.forRoot(),
      MasterDataModule.forRoot(),
      DeveloperModule.forRoot(),
      ConsoleModule.forRoot(),
      ItemScanModule.forRoot(),
      OfflineModule.forRoot(),
      SoftappsCoreModule.forRoot()
    ),
*/

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,
    ...vkforgContextProviders,

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,

    // MDE
    ...wwsCoreProviders,

    ...artikelvorratProviders,
    ...artikelInfoProviders,
    ...bestellerfassungProviders,
    ...bestellvorschlagProviders,
    ...etikettendruckProviders,
    ...provideMdeInventoryModule(),
    ...materiallieferscheinScanProviders,
    ...retourenProviders,
    ...warenverprobungProviders,
    ...warenuebernahmeProviders,
    ...eslLinkProviders,
    ...provideStorageLocation(),

    // Werkstatt
    provideGarageOrderModule(),
    provideGarageReport(),
    provideRoster(withGarageRoster()),
    provideGarageCore(),
    provideVehicleModule(),
    provideToolModule(),

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
